module.exports = __webpack_public_path__ + "img/tools_Benefit_Data_Services.10c4da59.jpg";